<template>
  <QuestionBase :errors="[...errorsPost, ...serverErrors, ...jsErrors]"
                :question="question"
                :valid="data !== null">
    <InputSelect v-model="data"
                 :args="args"
                 :db="db"
                 :errors-post="errorsPost"
                 :js-errors="jsErrors"
                 :no-save="noSave"
                 :options="options"
                 :skipped="skipped"
                 @jsErrors="jsErrors=$event"
                 @serverErrors="serverErrors=$event"
                 @skipped="skipped=$event" />
  </QuestionBase>
</template>

<script>
import {questionLoadHelpers} from "../../helpers/questionLoadHelpers";
import {clientPersonOptions} from "../../options/clientPersonOptions";

import QuestionBase from "../../QuestionBase";
import InputSelect from "../../inputs/InputSelect";

export default {
  name: 'Relationship',
  mixins: [
    questionLoadHelpers,
    clientPersonOptions
  ],
  components: {
    InputSelect,
    QuestionBase
  },
  props: {
    value: {
      type: String,
      required: false
    },
    errorsPost: {
      type: Array,
      default: () => {
        return []
      }
    },
    noSave: {
      type: Boolean,
      default: false
    },
    objectId: {
      type: [Number, String],
      required: false
    },
    friendOnly: {
      type: Boolean,
      default: false
    },
    partnerOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input',
            value)
      },
      get() {
        return this.value
      }
    },
    options () {
      if (this.friendOnly) return this.friendRelationshipOnly
      else if (this.partnerOnly) return this.partnerRelationshipOnly
      return this.relationshipOptions
    }
  },
  data() {
    return {
      question: {
        title: 'How is this person related to you?',
        subTitle: 'If the relationship is not listed, type the correct relationship into the box and when it appears underneath where you have typed click on it.',
        tip: null
      },
      db: {
        saveLocation: 'client_person',
        saveField: 'relationship_to_client',
        objectId: this.objectId
      },
      args: {
        taggable: true,
        label: null,
        placeholder: 'Please select..',
        skippable: false,
        required: true,
        inputClass: 'field-75'
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>
